import R from 'ramda'

const RETWEET_TRIGGER_TYPE = 'RETWEET_OF'
const RETWEET_DISPLAY_TYPE = 'Retweet of a Tweet'
const EXISTING_TWEET_ACTION = 'EXISTING_TWEET'

const isRetweetWidgetTrigger = R.propEq('type', RETWEET_TRIGGER_TYPE)

const convertRetweetWidgetTriggerToFormTrigger = R.applySpec({
  type: R.always(RETWEET_DISPLAY_TYPE),
  action: R.always(EXISTING_TWEET_ACTION),
  value: R.prop('data')
})

export { isRetweetWidgetTrigger, convertRetweetWidgetTriggerToFormTrigger }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/triggers/twitter/widget-to-form/retweet.js